import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice";

const houseRulesAdapter = createEntityAdapter({});

const initialState = houseRulesAdapter.getInitialState();

export const houseRulesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHouseRules: builder.query({
      query: () => "/houseRules",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedHouseRules = responseData.map((houseRule) => {
          houseRule.id = houseRule._id;
          return houseRule;
        });
        return houseRulesAdapter.setAll(initialState, loadedHouseRules);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "HouseRule", id: "LIST" },
            ...result.ids.map((id) => ({ type: "HouseRule", id })),
          ];
        } else return [{ type: "HouseRule", id: "LIST" }];
      },
    }),
    addNewHouseRule: builder.mutation({
      query: (initialHouseRuleData) => ({
        url: "/houseRules",
        method: "POST",
        body: {
          ...initialHouseRuleData,
        },
      }),
      invalidatesTags: [{ type: "HouseRule", id: "LIST" }],
    }),
    updateHouseRule: builder.mutation({
      query: (initialHouseRuleData) => ({
        url: "/houseRules",
        method: "PATCH",
        body: {
          ...initialHouseRuleData,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "HouseRule", id: arg.id },
      ],
    }),
    deleteHouseRule: builder.mutation({
      query: ({ id }) => ({
        url: `/houseRules`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "HouseRule", id: arg.id },
      ],
    }),
  }),
});

export const {
  useGetHouseRulesQuery,
  useAddNewHouseRuleMutation,
  useUpdateHouseRuleMutation,
  useDeleteHouseRuleMutation,
} = houseRulesApiSlice;

// // returns the query result object
// export const selectHouseRulesResult =
//   houseRulesApiSlice.endpoints.getHouseRules.select();

// // creates memoized selector
// const selectHouseRulesData = createSelector(
//   selectHouseRulesResult,
//   (houseRulesResult) => houseRulesResult.data // normalized state object with ids & entities
// );

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//   selectAll: selectAllHouseRules,
//   selectById: selectHouseRuleById,
//   selectIds: selectHouseRuleIds,
//   // Pass in a selector that returns the houseRules slice of state
// } = houseRulesAdapter.getSelectors(
//   (state) => selectHouseRulesData(state) ?? initialState
// );
